import { useEffect } from "react";

export function useForceBlankLinks({
  // CSS selector for links you want to catch:
  selector = 'a[href]:not([target]):not([download])',
  // Only apply to external links by default:
  externalOnly = true,
} = {}) {
  useEffect(() => {
    const onClick = (e) => {
      // Only left click, no modifier keys, and not already prevented
      if (
        e.defaultPrevented ||
        e.button !== 0 ||
        e.metaKey ||
        e.ctrlKey ||
        e.shiftKey ||
        e.altKey
      ) {
        return;
      }

      const a = e.target.closest(selector);
      if (!a) return;

      const href = a.getAttribute("href");
      if (!href) return;

      // Skip in-page anchors and special protocols
      if (
        href.startsWith("#") ||
        href.startsWith("mailto:") ||
        href.startsWith("tel:") ||
        href.startsWith("javascript:")
      ) {
        return;
      }

      // If it's a normal absolute/relative URL, we can resolve it
      let url;
      try {
        url = new URL(href, window.location.href);
      } catch {
        return;
      }

      // Optional: only external links
      if (externalOnly && url.origin === window.location.origin) return;

      // Let Gatsby internal navigation do its thing for internal links
      // (this guard is mostly redundant with externalOnly=true)
      a.setAttribute("target", "_blank");
      a.setAttribute("rel", "noopener noreferrer");
    };

    document.addEventListener("click", onClick, true); // capture helps with some widgets
    return () => document.removeEventListener("click", onClick, true);
  }, [selector, externalOnly]);
}
